import clsx from "clsx";
import { useLocalStorage } from "usehooks-ts";
import { COLOR_CLASS_NAMES } from "react-migration/components/Avatar";
import { useDropdownMenuContext } from "react-migration/components/DropdownMenu";
import { logEvent } from "react-migration/lib/util/logEvent";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";

export const UserColorMenu = () => {
  const { t } = useTranslation();

  const [userColor, setUserColor] = useLocalStorage<string | undefined>("userColor", undefined);

  const { closeMenu } = useDropdownMenuContext();

  const onSelectColour = async (color: string) => {
    setUserColor(color);
    logEvent("Toggle user color", { color });
    closeMenu();
  };

  return (
    <div className="flex flex-col items-center">
      <div className="grid gap-1 grid-cols-4 py-2 px-3.5 max-w-[136px]">
        {COLOR_CLASS_NAMES.map((color) => (
          <div
            key={color}
            data-testid="stage-color-item"
            className={clsx("h-6 w-6 rounded-xs transition duration-200 ease-in cursor-pointer hover:scale-110", color)}
            onClick={() => onSelectColour(color)}
          >
            {color === userColor && (
              <i className="flex text-2xl text-center text-white icon-lt-check-line align-center" />
            )}
          </div>
        ))}
        <div />
        <div
          onClick={() => setUserColor(undefined)}
          title="Reset to default"
          className={clsx(
            "h-6 w-6 rounded-xs transition duration-200 ease-in cursor-pointer hover:scale-110 flex items-center justify-center bg-background-surface-neutral-subtle text-text-base-tertiary"
          )}
        >
          <i className="text-lg icon-lt-refresh-line" />
        </div>
      </div>
      <div className="px-4 pb-2 text-xs text-text-base-tertiary">{t("nav.user.color.description")}</div>
    </div>
  );
};
